import React from 'react';
import ReactDOM from 'react-dom';
import './reset.css'
import './index.css';
import Layout from './Layout';
import reportWebVitals from './reportWebVitals';
import { AnimateSharedLayout } from "framer-motion";

ReactDOM.render(
  <React.StrictMode>
    <AnimateSharedLayout>
      <Layout />
    </AnimateSharedLayout>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
